@if (showModal) {
  @switch (showModal.component) {
    @case (ShowModalComponents.PAYOUT) {
      <app-payouts-detail-modal
        #payoutsDetailModal
        [openWith]="showModal.data"
        (modalDismissedFired)="
          modalDismissed(showModal.component, $event)
        "></app-payouts-detail-modal>
    }

    @case (ShowModalComponents.PAYOUT_OVERVIEW) {
      <app-payouts-overview-modal
        #payoutsDetailModal
        [openWith]="showModal.data"
        (valueChanged)="fireEvent('valueChanged', $event)"
        (modalDismissedFired)="
          modalDismissed(showModal.component, $event)
        "></app-payouts-overview-modal>
    }
  }
}
